// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase :{
    apiKey: "AIzaSyA8Hntzl8n_6sXjsDFVNQtRrlLpjrRwaIk",
    authDomain: "arkaddi-6ab01.firebaseapp.com",
    databaseURL: "https://arkaddi-6ab01-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "arkaddi-6ab01",
    storageBucket: "arkaddi-6ab01.appspot.com",
    messagingSenderId: "202985469474",
    appId: "1:202985469474:web:10905f5a22c08b6817fc7b"
  }
  
};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
